<mat-form-field>
  <label>Detection Model</label>
  <mat-select [(ngModel)]="selectedModel" (selectionChange)="saveNewModel($event.value.MID)">
    <option value="selectedModel.name" selected></option>
    <mat-option *ngFor="let model of models" [value]="model">
      {{ model.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
